import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseRewardItemsProps<T> = {
  filters?: {
    search?: string
    page?: number
    status?: string
    establishmentCompanyBranchId?: string
    availableFromFrom?: string
    availableFromTo?: string
  }
  mapper?: (data: any) => T,
}

export const useRewardItems = <T,>({
  filters: {
    search = '',
    page,
    status,
    establishmentCompanyBranchId,
    availableFromFrom,
    availableFromTo,
  } = {},
  mapper = Mapper.default<T>(),
}: UseRewardItemsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['rewardItems', search, page, status, establishmentCompanyBranchId, availableFromFrom, availableFromTo],
    queryFn: () => {
      return privateAxios.get(`/tmais/products`, {
        params: {
          search,
          page,
          'q[status_eq]': status,
          'q[establishment_company_branch_id_eq]': establishmentCompanyBranchId,
          'q[available_from_gteq]': availableFromFrom,
          'q[available_from_lteq]': availableFromTo,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
